/* eslint-disable jsx-a11y/anchor-is-valid */
import { formatISO9075 } from 'date-fns';
import React from 'react';
import { Link } from 'react-router-dom';

const Post = ({ _id, title, summary, cover, content, createdAt, author }) => {
  const serverURL =
    process.env.REACT_APP_NODE_ENV === 'production'
      ? process.env.REACT_APP_SERVER_PROD_URL
      : 'http://localhost:4000';
  return (
    <div className='post' style={{ margin: '5%' }}>
      <div className='image'>
        <Link to={`/post/${_id}`}>
          <img
            src={`${serverURL}/${cover}`}
            alt={title}
            style={{ borderRadius: '5%' }}
          />
        </Link>
      </div>
      <div className='texts'>
        <Link to={`/post/${_id}`}>
          <h2>{title}</h2>
        </Link>
        <p className='info'>
          <a className='author'>{author.username}</a>
          <time>{formatISO9075(new Date(createdAt))}</time>
        </p>
        <p className='summary'>{summary}</p>
      </div>
    </div>
  );
};

export default Post;
